import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnicorn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconUnicorn"><Path d="M17 2.88184V6.73431L17.0069 6.74642L23.5 3.49988L18.8003 9.88476C19.5022 11.1131 20.343 12.2016 20.8488 13.4208C21.3962 14.7404 20.7905 16.1697 19.8627 17.256L19.3991 17.7989C19.0635 18.1918 18.5882 18.4489 18.0851 18.4318C17.9508 18.4272 17.8202 18.3848 17.6956 18.3343C14.9551 17.2224 13.948 16.4766 11.6468 15.4413C12.0182 17.2178 11.9249 19.1285 12.0266 20.9423L1 18.9999C1 12.8591 4 5.5 12.9849 4.88941L17 2.88184Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnicorn;
